import React, { useMemo } from "react";
import ExcelGrid from "components/ExcelGrid";
import { buildCostOfIssuanceReport } from "pages/DebtStudio/lib/buildCostOfIssuanceReport";

const formatAmount = (value) =>
  value == null
    ? ""
    : Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

const formatPercentOfPar = (value) =>
  value == null
    ? ""
    : Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 5,
        maximumFractionDigits: 5,
      });

const columns = [
  {
    key: "label",
    label: "Cost of Issuance",
  },
  {
    key: "percentOfPar",
    label: "% of Par",
    numeric: true,
    width: "w-40",
    className: "text-right numeric",
    headerClassName: "text-right",
    format: formatPercentOfPar,
  },
  {
    key: "amount",
    label: "Amount",
    numeric: true,
    width: "w-48",
    className: "text-right numeric",
    headerClassName: "text-right",
    format: formatAmount,
  },
];

export default function CostOfIssuanceReport({ items = [], parAmount = 0 }) {
  const report = useMemo(
    () => buildCostOfIssuanceReport(items, parAmount),
    [items, parAmount]
  );

  if (!report.rows.length) {
    return <div className="p-4 text-muted">No costs of issuance available.</div>;
  }

  return (
    <ExcelGrid
      columns={columns}
      rows={[...report.rows, report.total]}
      rowClassName={(row) =>
        row?.isTotal ? "border-t border-border font-semibold" : ""
      }
      readOnly
    />
  );
}
